// import { createRouter, createWebHistory } from 'vue-router';
// import type { RouteRecordRaw } from 'vue-router';
// import { useAuthStore } from '@/stores/authStore';
// import LoginView from '@/views/LoginView.vue';
// import MainLayout from '@/layouts/MainLayout.vue';
// import DashboardView from '@/views/DashboardView.vue';
// import ReceivingView from '@/views/ReceivingView.vue';
// import CollectionsView from '@/views/CollectionsView.vue';
// import ReportsView from '@/views/ReportsView.vue';
// import Settings from '@/views/Settings.vue';
// import ForgotPassPage from '@/views/ForgotPassPage.vue';
// import ActivationPage from '@/views/ActivationPage.vue';

// const routes: RouteRecordRaw[] = [
//   {
//     path: '/login',
//     name: 'Login',
//     component: LoginView,
//     meta: { requiresAuth: false }
//   },
//   {
//     path: '/forgotpassword',
//     name: 'Forgot Password',
//     component: ForgotPassPage,
//     meta: { requiresAuth: false }
//   },
//   {
//     path: '/activationpage',
//     name: 'Activation Page',
//     component: ActivationPage,
//     meta: { requiresAuth: false }
//   },
//   {
//     path: '/',
//     component: MainLayout,
//     meta: { requiresAuth: true },
//     children: [
//       {
//         path: '',
//         redirect: '/dashboard'
//       },
//       {
//         path: 'dashboard',
//         name: 'Dashboard',
//         component: DashboardView
//       },
//       {
//         path: 'receiving',
//         name: 'Receiving',
//         component:ReceivingView
//       },
//       {
//         path: 'collections',
//         name: 'Collections',
//         component:CollectionsView
//       },
//       {
//         path: 'reports',
//         name: 'Reports',
//         component: ReportsView
//       },
//       {
//         path: 'settings',
//         name: 'Settings',
//         component:Settings,
//         meta: { roles: ['superuser'] }
//       },

//     ]
//   },
//   {
//     path: '/:pathMatch(.*)*',
//     redirect: '/dashboard'
//   }
// ];

// const router = createRouter({
//   history: createWebHistory(),
//   routes
// });

// // router.beforeEach(async (to, from, next) => {
// //   const authStore = useAuthStore();
  
// //   if (!authStore.isAuthenticated) {
// //     await authStore.checkAuth();
// //   }

// //   const requiresAuth = to.matched.some(record => record.meta.requiresAuth !== false);

// //   if (requiresAuth && !authStore.isAuthenticated) {
// //     next('/login');
// //   } else if (to.path === '/login' && authStore.isAuthenticated) {
// //     next('/dashboard');
// //   } else {
// //     next();
// //   }
// // });
// router.beforeEach(async (to, from, next) => {
//   const authStore = useAuthStore();

//   if (!authStore.isAuthenticated) {
//     await authStore.checkAuth();
//   }

//   const requiresAuth = to.matched.some(
//     record => record.meta.requiresAuth !== false
//   );

//   if (requiresAuth && !authStore.isAuthenticated) {
//     return next('/login');
//   }

//   const allowedRoles = to.matched
//     .flatMap(record => record.meta.roles || []);

//   if (
//     allowedRoles.length > 0 &&
//     !allowedRoles.includes(authStore.userRole)
//   ) {
//     return next('/dashboard'); 
//   }

//   if (to.path === '/login' && authStore.isAuthenticated) {
//     return next('/dashboard');
//   }

//   next();
// });


// export default router;
import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores/authStore'; 
import LoginView from '@/views/LoginView.vue';
import MainLayout from '@/layouts/MainLayout.vue';
import DashboardView from '@/views/DashboardView.vue';
import ReceivingView from '@/views/ReceivingView.vue';
import CollectionsView from '@/views/CollectionsView.vue';
import ReportsView from '@/views/ReportsView.vue';
import Settings from '@/views/Settings.vue';
import ForgotPassPage from '@/views/ForgotPassPage.vue';
import ActivationPage from '@/views/ActivationPage.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { requiresAuth: false }
  },
  {
    path: '/forgotpassword',
    name: 'Forgot Password',
    component: ForgotPassPage,
    meta: { requiresAuth: false }
  },
  {
    path: '/activationpage',
    name: 'Activation Page',
    component: ActivationPage,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/dashboard'
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: DashboardView
      },
      {
        path: 'receiving',
        name: 'Receiving',
        component: ReceivingView
      },
      {
        path: 'collections',
        name: 'Collections',
        component: CollectionsView
      },
      {
        path: 'reports',
        name: 'Reports',
        component: ReportsView
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings,
        meta: { roles: ['Full Access'] } 
      },
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/dashboard'
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  if (!authStore.isAuthenticated && localStorage.getItem('activeUserID')) {
    await authStore.fetchUser();
  }

  const userEmail = authStore.user?.emailAddress?.toLowerCase() || "";
  const userRole = authStore.userRole;
  const isSuperuser = userEmail === "superuser@ram.co.za";

  const requiresAuth = to.matched.some(
    record => record.meta.requiresAuth !== false
  );

  if (requiresAuth && !authStore.isAuthenticated) {
    return next('/login');
  }
  if (authStore.isAuthenticated && isSuperuser) {
    if (to.path !== '/settings') {
      return next('/settings');
    }
    return next();
  }
  const allowedRoles = to.matched.flatMap(record => record.meta.roles || []);

  if (allowedRoles.length > 0) {
    if (!allowedRoles.includes(userRole)) {
      return next('/dashboard'); 
    }
  }
  if (to.path === '/login' && authStore.isAuthenticated) {
    return next(isSuperuser ? '/settings' : '/dashboard');
  }

  next();
});

export default router;